module.exports = __webpack_public_path__ + "static/media/Gmail.69efed34.svg";